import React, {useEffect, useState} from "react";
import {Outlet, useLocation} from 'react-router-dom';
import AppConfigContext from "../../../tools/contexts/tosan/AppConfigContext";
import themes from "../../../tools/defaults/tosan/themes";
import DataContext from "../../../tools/contexts/tosan/DataContext";
import {ModalContainer, Reoverlay} from "reoverlay";
const TosanLayout = ({children}) => {
    const {state}=useLocation();

    const [theme, setTheme] = useState("theme-default");
    const [bills, setBills] = useState([]);
    const [currentBill, setCurrentBill] = useState(null);
    const [loading, setLoading] = useState(true);
    const [token,setToken]=useState(state?.token||localStorage.getItem('t_token'));
    const [error,setError]=useState(null);

    const handleError=(newError)=>{
        setError(newError)
    }
    const handleToken=(newToken)=>{
        setToken(newToken)
    }
    const handleTheme = (newTheme) => {
        if (themes.includes(newTheme)) {
            setTheme(newTheme)
        } else {
            setTheme("theme-default")
        }
    }
    const handleBills = (newBills) => setBills([...newBills])
    const handleCurrentBill = (newCurrentBill) => setCurrentBill({...newCurrentBill})
    const handleLoading = (newLoading) => {

        setLoading(newLoading)
    }
    return <>
        <AppConfigContext.Provider value={{
            theme: theme,
            handleTheme,
        }}>
            <DataContext.Provider value={{
                bills,
                currentBill,
                loading,
                handleBills,
                handleCurrentBill,
                handleLoading,
                token,
                handleToken,
                error,
                handleError,
            }}>
                <div data-theme={theme} className="min-h-screen w-full tosan-layout  bg-gray-100  ">
                    {<Outlet/>}
                    <ModalContainer/>
                </div>

            </DataContext.Provider>

        </AppConfigContext.Provider>


    </>

}
export default TosanLayout;